import classNames from 'classnames'
import React, { CSSProperties, FC, SVGProps, SyntheticEvent } from 'react'

export interface IconProps {
  iconSvg: FC<SVGProps<SVGElement>>
  onClick?: (event: SyntheticEvent) => void
  className?: string
  style?: CSSProperties
  dataTestId?: string
}

const Icon = ({ iconSvg: IconSVG, onClick, className, style, dataTestId }: IconProps) => {
  return (
    <>
      {IconSVG && (
        <IconSVG
          // @i18n-ignore
          role="presentation"
          className={classNames(
            {
              'cursor--pointer': !!onClick,
            },
            className,
          )}
          onClick={onClick}
          style={style}
          data-testid={dataTestId}
        />
      )}
    </>
  )
}

export default Icon
